import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, withCtx as _withCtx, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-bbf54422"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "queue-card__left-content" }
const _hoisted_2 = { class: "queue-card__name" }
const _hoisted_3 = { class: "queue-card__right-content" }
const _hoisted_4 = { class: "queue-card__tasks-count" }
const _hoisted_5 = {
  key: 1,
  class: "queue-card__actions"
}
const _hoisted_6 = { class: "sidebar-tree-item__dots-icon" }

import { computed, inject, PropType, watch } from 'vue';
import { QueueCardtemModel } from './models';
import { EllipsisHorizontalIcon, ListBulletIcon } from 'tir-style-system/icons/outline';
import {
  TirPmButton,
  TirPmButtonVariantEnum,
  TirPmButtonSizeEnum,
  PopoverPositionEnum,
} from 'tir-components';
import { RouteLocationRaw, RouterLink, useRouter } from 'vue-router';
import SidebarMorePopover from '../sidebar/components/sidebar-more-popover/sidebar-more-popover.vue';
import { QueueTasksModel } from '../sidebar/models';
import EditQueueModal from '../edit-queue-modal/edit-queue-modal.vue';
import { ref } from 'vue';
import { ComputedRef } from 'vue';
import { CurrentUser, UserRoleEnum } from 'tir-pm-user-core';
import { ParentTaskPlate } from '../parent-task-plate';


export default /*#__PURE__*/_defineComponent({
  __name: 'queue-card',
  props: {
  /**Очередь */
  queue: {
    type: Object as PropType<QueueCardtemModel>,
    required: true,
  },
},
  emits: ["onDeleteQueue", "onUpdateQueue"],
  setup(__props, { emit }) {

const props = __props;

const router = useRouter();



/**Владелец */
const isOwner = computed(() => CurrentUser.Roles.includes(UserRoleEnum.Owner));
/**Админ проекта */
const isProjectAdmin = inject('isAdminProject') as ComputedRef<boolean>;
/**Админ неймспейса */
const isNamespaceAdmin = inject('isAdminNamespace') as ComputedRef<boolean>;
/**Флаг для открытия очереди */
const openQueue = ref(true);



/**Id редактируемой очереди */
const editQueue = ref<QueueTasksModel>();

/** Открытие окна для редактирования очереди  */

const toggleVisible = ref();

const checkToggleVisible = (value) => {
  toggleVisible.value = value;
};

const openEditQueueModal = () => {
  if (props.queue.isQueue()) {
    editQueue.value = props.queue;
  }
};

const togglePopover = () => {
  openQueue.value = false;
};
/**
 * * Закрыть окно редактирования очереди
 */
const closeEditQueueModal = () => (editQueue.value = undefined);

/**
 * * Получить текст с кол-во задач
 * @param count Кол-во задач
 */
const getTasksCountText = (count: number) => {
  const remainder10 = count % 10;
  const remainder100 = count % 100;

  if (remainder10 === 1 && remainder100 !== 11) {
    return `${count} задача`;
  } else if (remainder10 >= 2 && remainder10 <= 4 && !(remainder100 >= 12 && remainder100 <= 14)) {
    return `${count} задачи`;
  } else {
    return `${count} задач`;
  }
};
/**Текст с количеством задач */
const tasksCountText = computed(() => getTasksCountText(props.queue.TasksCount));
/**Путь до очереди */
const queueRoute = computed<RouteLocationRaw>(() => {
  return {
    name: 'queue',
    params: {
      queueId: props.queue.Id,
    },
  };
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(RouterLink), {
    class: "queue-card",
    to: queueRoute.value
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_unref(ListBulletIcon), { class: "queue-card__icon" }),
        _createElementVNode("span", _hoisted_2, _toDisplayString(__props.queue.Name), 1)
      ]),
      _createElementVNode("div", _hoisted_3, [
        (__props.queue.ParentTask)
          ? (_openBlock(), _createBlock(_unref(ParentTaskPlate), {
              key: 0,
              "is-short": "",
              task: __props.queue.ParentTask
            }, null, 8, ["task"]))
          : _createCommentVNode("", true),
        _createElementVNode("span", _hoisted_4, _toDisplayString(tasksCountText.value), 1),
        (isOwner.value || _unref(isProjectAdmin) || _unref(isNamespaceAdmin))
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              (_openBlock(), _createBlock(SidebarMorePopover, {
                position: _unref(PopoverPositionEnum).Left,
                "menu-item": __props.queue,
                key: __props.queue.Name,
                onOnDeleteQueue: _cache[0] || (_cache[0] = ($event: any) => (emit('onDeleteQueue', $event))),
                onOnUpdateQueue: _cache[1] || (_cache[1] = ($event: any) => (emit('onUpdateQueue', $event))),
                onEditQueue: openEditQueueModal,
                onToggleVisible: checkToggleVisible
              }, {
                target: _withCtx(() => [
                  _createVNode(_unref(TirPmButton), {
                    variant: _unref(TirPmButtonVariantEnum).LinkState,
                    size: _unref(TirPmButtonSizeEnum).Regular,
                    isPressed: toggleVisible.value,
                    onClick: _withModifiers(togglePopover, ["prevent"])
                  }, {
                    leftSlot: _withCtx(() => [
                      _createElementVNode("div", _hoisted_6, [
                        _createVNode(_unref(EllipsisHorizontalIcon), {
                          style: {"width":"1.5rem"},
                          class: "menu__controls-icon"
                        })
                      ])
                    ]),
                    _: 1
                  }, 8, ["variant", "size", "isPressed", "onClick"])
                ]),
                _: 1
              }, 8, ["position", "menu-item"]))
            ]))
          : _createCommentVNode("", true)
      ]),
      _createVNode(EditQueueModal, {
        queue: editQueue.value,
        onClose: closeEditQueueModal
      }, null, 8, ["queue"])
    ]),
    _: 1
  }, 8, ["to"]))
}
}

})